module.exports = __webpack_public_path__ + "img/tooltip_01-VALLONE_FINISH_HST_K21_LEGNO_SPRING_CORREZ_COLOR.209a383a.jpg";